export const TITULAR = "T";
export const SUPLENTE = "S";
export const DIRECTOR_TECNICO = "E";
